import {Box} from "@mui/material";

interface Props {
    children: React.ReactNode
}

export const Kbd: React.FC<Props> = ({children}) => (
    <Box
        component="kbd"
        sx={{
            display: 'inline-block',
            px: 0.75,
            py: 0.25,
            fontSize: '0.65rem',
            fontFamily: 'monospace',
            fontWeight: 500,
            lineHeight: 1,
            color: 'text.primary',
            bgcolor: 'grey.100',
            border: '1px solid',
            borderColor: 'grey.300',
            borderRadius: 0.5,
            boxShadow: '0 1px 0 1px rgba(0,0,0,0.05), 0 1px 0 rgba(0,0,0,0.1)',
        }}
    >
        {children}
    </Box>
);